import {toast, ToastCard} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export type BuyerDeletedToastProps = {
  toastId: string | number;
};

export const BuyerDeletedToast: FC<BuyerDeletedToastProps> = ({toastId}) => {
  const {t} = useTranslation('trustAccounts');

  return (
    <ToastCard
      iconName="sollapay:check"
      title={t('view.buyers.detail.deleteBuyer.success.title')}
      description={t('view.buyers.detail.deleteBuyer.success.description')}
      onClose={() => toast.dismiss(toastId)}
      closeLabel={t('view.buyers.detail.toastClose')}
    />
  );
};

export function showBuyerDeletedToast(): void {
  toast.custom(id => <BuyerDeletedToast toastId={id} />, {duration: 10_000});
}
